import { ProfileOutline } from '@components/atoms';
import Picture from '../picture/picture';
import type { ProfileAvatarProps } from './profile-avatar.type';

const DEFAULT_SIZE = '4'; // Default size in rem

export const ProfileAvatar = ({ name, profilePictureUrl, size = DEFAULT_SIZE }: ProfileAvatarProps) => {
	const avatarSizeClass = `w-${size} h-${size}`;
	return profilePictureUrl ? (
		<Picture path={profilePictureUrl} alt={name} className={`${avatarSizeClass} shrink-0 rounded-full`} />
	) : (
		<ProfileOutline className={`${avatarSizeClass} shrink-0 rounded-full`} />
	);
};
